import { createApp } from 'vue';
import Statistics from './statistics/Statistics.vue';

export const statistics = () => {
  if (!document.querySelector('#offer-statistics')) {
    return;
  }

  const component = {
    components: { Statistics },
    template: '<Statistics/>',
  };

  createApp(component).mount('#offer-statistics');
};
